<template>
  <BaseSelect
    v-model="modelValue"
    v-bind="$attrs"
    v-on="$listeners"
    :options="BDXManagementTableFiltersRECStatusOptions"
    label="REC"
    size="sm"
  />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { BaseSelect } from '@components/base'

import { BDXManagementTableFiltersRECStatusOptions } from './BDXManagementTableFilters.constants'

export default defineComponent({
  name: 'BDXManagementTableFiltersRECStatus',
  components: {
    BaseSelect
  },
  props: {
    value: {
      type: String,
      default: 'All'
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      BDXManagementTableFiltersRECStatusOptions,

      modelValue
    }
  }
})
</script>
